import i18n from "../../constants/i18n";
import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import Et3Text from "../../core/et3-text";
import { reduce } from "et3-type-guards";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import getCoreUIStore from "../../stores/core/core-ui-store";
import getDashBoardStore from "../../stores/dashboard-store";
import et3ReadableDate from "../../helpers/et3-date-helper";
import { ThreeDots } from "react-loader-spinner";
import getCoreTimingStore from "../../stores/core/core-timing-store";
import Et3Image from "../../core/et3-Image";
import ET3Circle from "../../core/et3-circle";

const UserInfo = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX } = theme;
  const user = getCorePersonalStore().user.get();
  const isAnyKhattabaAdmin = getCorePersonalStore().isAnyKhattabaAdmin.get();
  const username = reduce(() => user.username, "");
  const isLoading = getCoreUIStore().isLatestDataLoading.get();
  const activeTime = getDashBoardStore().activeTime.get();
  const countDownTime = isAnyKhattabaAdmin
    ? getCoreTimingStore().khattabatCountDownTime.get() * 1000
    : getCoreTimingStore().countDownTime.get() * 1000;
  const userImageName = getCorePersonalStore().userPofilePic.get();
  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      withShadow={false}
      width={300}
      height={200}
      fDirection="column"
      alignItems="center"
      justifyContent="flex-start"
      color={colors.all.transparent}
      style={{}}
      onClick={() => { }}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={300}
        height={70}
        fDirection="row"
        alignItems="center"
        justifyContent="center"
        color={colors.all.transparent}
        style={{}}
        onClick={() => { }}
      >
        <ET3Circle
          withShadow={false}
          size={50}
          color={colors.all.transparent}
          style={{
            borderRadius: 50 * unitX
          }}
          onClick={() => { }}
        >
          <Et3Image
            type="LOCAL"
            alt={i18n.get("ALKHATTABA_ADMIN")}
            imageName={userImageName}
            size={50}
            onClick={() => { }}
            style={{}}
          />
        </ET3Circle>
      </ET3Div>
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        withShadow={false}
        width={250}
        height={150}
        fDirection="column"
        alignItems="center"
        justifyContent="center"
        color={colors.all.transparent}
        style={{}}
        onClick={() => { }}
      >
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={16}
          text={username}
          isSpan={false}
          color={colors.all.white}
          style={{
            width: 250 * unitX,
            wordWrap: "break-word"
          }}
        />
        <ET3Div
          isScrollable={false}
          isExtendable={false}
          withShadow={false}
          width={230}
          height={15}
          fDirection="column"
          alignItems="center"
          justifyContent="center"
          color={colors.all.transparent}
          style={{}}
          onClick={() => { }}
        >
          {isLoading ? (
            <ThreeDots color={colors.all.cyan} height={15} width={50} />
          ) : (
            <Et3Text
              fontFamily={"MEDIUM"}
              fontSize={16}
              text={`${i18n.get("ACTIVE")} - ${et3ReadableDate(activeTime)}`}
              isSpan={false}
              color={colors.all.cyan}
              style={{
                width: 230 * unitX,
                wordWrap: "break-word"
              }}
            />
          )}
        </ET3Div>
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={16}
          text={`${i18n.get("REFRESH")} - ${et3ReadableDate(countDownTime)}`}
          isSpan={false}
          color={colors.all.yellow}
          style={{
            width: 230 * unitX,
            wordWrap: "break-word"
          }}
        />
      </ET3Div>
    </ET3Div>
  );
});
export default UserInfo;
